import React from "react";
import "./PortfolioDetailCard.scss";
import { map, isEmpty } from "lodash";
import { portfolioMetadataMap } from "utils/individualPortfolioHelper";
import { formatPercentage } from "utils/number";

import { Card, ListGroup, ListGroupItem } from "react-bootstrap";

interface PortfolioAsset {
  id?: string;
  symbol?: string;
  allocation?: number;
  assets?: string;
}

interface Portfolio {
  name?: string;
  label?: string;
  description?: string;
  portfolioName?: string;
  assets?: PortfolioAsset[];
}

interface PortfolioMetadata {
  label?: string;
  risk?: string;
  portfolio?: string;
  stock?: string;
  bond?: string;
  description?: string;
  key?: string;
}

interface Props {
  portfolio?: Portfolio;
  isSelected?: boolean;
  onSelect?: (...args: unknown[]) => void;
}

const PortfolioDetailCard = ({ portfolio = {} }: Props) => {
  const { assets, portfolioName } = portfolio;

  const portfolioMetadata = portfolioMetadataMap[
    portfolioName as keyof typeof portfolioMetadataMap
  ] as PortfolioMetadata;

  if (isEmpty(portfolio) || isEmpty(portfolioMetadata)) return null;

  return (
    <div className="portfolio-card">
      <Card className="portfolio-detail">
        <Card.Body>
          <Card.Title className="card-title">
            <p className="card-label"> {portfolioMetadata.portfolio}</p>
            <p className="card-details">Portfolio</p>
          </Card.Title>
          <div className="card-description">
            <p className="stock-bond-allocation">
              {portfolioMetadata.stock}
              {portfolioMetadata.stock && portfolioMetadata.bond && (
                <span className="divider">|</span>
              )}
              {portfolioMetadata.bond}
            </p>
            <p className="card-text">{portfolioMetadata.description}</p>
          </div>
        </Card.Body>
        <Card.Body className="asset-breakdown">Breakdown of assets</Card.Body>
        <ListGroup className="list-group-flush">
          {map(assets, (asset) => (
            <ListGroupItem key={asset.id}>
              <div className="asset-details">
                <div className="stock-symbol">
                  <p className="sym">{asset.symbol}</p>
                </div>
                {/* <p className="asset-name">Domestic equity</p> */}
                <p className="asset-percentage">
                  {formatPercentage(asset.allocation as number, 0)}
                </p>
              </div>
              <div className="allocation-bar">
                <div
                  className="allocation-fill"
                  style={{
                    width: formatPercentage(asset.allocation as number, 0),
                  }}
                ></div>
              </div>
            </ListGroupItem>
          ))}
        </ListGroup>
      </Card>
    </div>
  );
};

export default PortfolioDetailCard;
